import isWebpNotSupport from '@src/utils/is-webp-not-support';
import { isBase64ImageString } from '@src/utils/data-utils';

const splitAt = (source, index) => [source.slice(0, index), source.slice(index)];

/**
 * 缓存池
 * @type {{}}
 */
const cachePool = {};

/**
 * 将原 url 地址转换成 webp 地址, 内部会判断是否支持 webp 环境和 base64
 * 注意: 仅用于当前本地项目, 由于本地项目会直接生成 webp
 *
 * 例如:
 * 原写法:
 * require('./images/bg.png')
 *
 * 支持 webp 写法:
 * toWebpImage(require('./images/bg.png'))
 *
 *  e.g.
 *
 * convert2Webp('/images/aa.png')
 * "/images/aa.png.webp"
 *
 * convert2Webp('/images/aa1.png')
 * "/images/aa1.png.webp"
 *
 * convert2Webp('/images/aa.png1')
 * "/images/aa.png1"
 *
 * convert2Webp('/images/aa.png?aa=123')
 * "/images/aa.png.webp?aa=123"
 *
 * convert2Webp('/images/aa.jpg?aa=123')
 * "/images/aa.jpg.webp?aa=123"
 *
 * @param {string} imageUrl - 图片地址
 * @param {boolean} [cache] - 是否开启缓存, 默认: true
 * @returns {string|*}
 */
export default function toWebpImage(imageUrl, { cache = true } = {}) {
  if (cache && cachePool[imageUrl]) {
    return cachePool[imageUrl];
  }
  if (isWebpNotSupport()) {
    return imageUrl;
  }
  if (isBase64ImageString(imageUrl)) {
    return imageUrl;
  }
  if (/(png|jpe?g)\.webp/.test(imageUrl)) {
    return imageUrl;
  }
  const [remaining, extension] = splitAt(imageUrl, imageUrl.lastIndexOf('.') + 1);
  const finalImageUrl = [remaining, extension.replace(/(png|jpe?g)(?!\w)/, '$1.webp')].join('');
  if (cache) {
    cachePool[imageUrl] = finalImageUrl;
  }
  return finalImageUrl;
}

/**
 * 转换成多个 webpImage 列表
 * @param {string[]} imageUrls - 图片地址
 * @param {boolean} [cache] - 是否开启缓存, 默认: true
 * @returns {string[]}
 */
export function toWebpImages(imageUrls, { cache = true } = {}) {
  return imageUrls.map(imageUrl => {
    return toWebpImage(imageUrl, { cache });
  });
}
